var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nmodule"},[_c('ntitle',{attrs:{"link":_vm.link}},[_vm._v("\n        "+_vm._s(_vm.title)+"\n        "),_c('template',{slot:"control"},[_vm._t("control")],2)],2),_c('div',{staticClass:"modu"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }